






import { defineComponent, ref } from '@vue/composition-api'
import {SfPrice} from '@storefront-ui/vue';
import { PropType } from 'vue';
import { PriceRangeType } from '~/utils/types';

export default defineComponent({
    components:{
        SfPrice
    },
    props:{
        priceRange:{
            type: Object as PropType<PriceRangeType>,
                required: true
        },
        specialPrice:{
            type: Number
        },
        specialFromDate:{
            type: String
        },
        specialToDate:{
            type: String
        }
    },
    setup(props) {
        const specialPriceCalculated = ref<number|undefined>(undefined);
        const today : number =  new Date().getTime() as number;
        const hasFrom = !!props.specialFromDate;
        const hasTo = !!props.specialToDate;
        const specialFromTimestamp : number = (hasFrom ? new Date(props.specialFromDate).getTime():0) as number;
        const specialToTimestamp : number = (hasTo ? new Date(props.specialToDate).getTime():0) as number;
        /**
         * Managing all cases. The special price is not applied if today not covers the inserted dates, but is applied if no date is inserted.
         */
        if(
            (hasFrom && hasTo && (specialFromTimestamp < today && today < specialToTimestamp))
            || (hasFrom && !hasTo && today > specialFromTimestamp)
            || (!hasFrom && hasTo && today < specialToTimestamp)
            || (!hasFrom && !hasTo)
        ){
            specialPriceCalculated.value = props.specialPrice;
        }

        return {specialPriceCalculated}
    },
})
